import React from 'react'
// import { ThemeContext } from '../Context/ThemeContextProvider'

export default function User({isDarkTheme, user}) {

    // const {themes}=useContext(ThemeContext)
    return (
        <div data-testid = "user" key={user.id} style={{ 
            color: isDarkTheme ? 'white' : 'black',
        }}>
            <img src={user.img} alt='name'/>
            <h2>{user.name}</h2>
            <p>{user.position}</p>
            <input data-testid = "level" type = "range" style={{  accentColor: isDarkTheme ? 'yellow' : 'blue' }}/>
            <p>Professional level: {user.level}</p>
            <p>Points : {user.points}</p>
        </div>
    )
}
